<template>
  <div>
    <a-modal
      v-model="isShow"
      centered
      :mask-closable="false"
      :ok-button-props="{ props: { loading: submitting } }"
      :title="isUpdate ? '修改送达信息' : '确认送达'"
      @ok="handleSubmit"
    >
      <a-form
        class="custom-compact-form"
        :form="form"
        :label-col="{ span: 6 }"
        :wrapper-col="{ span: 15 }"
        @submit="handleSubmit"
      >
        <a-form-item label="接收人">
          <a-input
            v-decorator="['receiver', {
              normalize: this.$lodash.trim,
              rules: [
                { required: true, message: '请输入接收人' },
                { max: 20, message: '最多20个字符' },
              ]
            }]"
            autocomplete="off"
          />
        </a-form-item>
        <a-form-item label="联系电话">
          <a-input
            v-decorator="['receiver_phone', {
              normalize: this.$lodash.trim,
              rules: [
                { required: true, message: '请输入联系电话' },
                { pattern: /^1[3-9]\d{9}$/, message: '联系电话格式不正确' },
                { max: 11, message: '联系电话最多11位'},
              ]
            }]"
            autocomplete="off"
          />
        </a-form-item>
        <a-form-item label="送达照片">
          <div
            style="line-height: 20px;margin-top: 10px;margin-bottom: 10px"
          >确认送达需要上传接收照片，支持png/jpg图片格式，建议尺寸宽高比180:180px，最多9张
          </div>
          <upload-image
            :is-add-watermark="isAddWatermark"
            accept=".jpg,.jpeg,.png"
            :max-count="9"
            :multiple="true"
            :default-file-list="attachments"
            @change="handleUploadImage"
            v-decorator="['attachments',{
              rules:[
                {validator: checkAttachments}
              ]
            }]"
          />
        </a-form-item>
        <a-form-item label="备注">
          <a-textarea
            v-decorator="['remark', {
              rules: [
                { message: '请输入备注' },
                { max: 200, message: '最多200个字符' },
              ]
            }]"
          />
        </a-form-item>
      </a-form>
    </a-modal>
  </div>
</template>

<script>
import UploadImage from '@/components/Upload/Image'
import { subscribeOrderDelivered, findSubscribeOrderDelivered, updateSubscribeOrderDelivered } from '@/api/subscribe_order'
import { additionalItemOrderDelivered, updateAdditionalItemOrderDelivered, findAdditionalItemOrderDelivered } from '@/api/additional_item_order'

export default {
  name: 'SubscribeOrderDeliver',
  components: {
    UploadImage
  },
  props: {
    visible: {
      type: Boolean,
      required: true
    },
    serviceOrderId: {
      type: Number,
      required: true
    },
    orderType: {
      type: String,
      required: true
    },
    isUpdate: {
      type: Boolean,
      required: true,
      default() {
        return false
      }
    }
  },
  data() {
    return {
      form: this.$form.createForm(this, { name: 'subscribeOrderDelivered' }),
      submitting: false,
      data: {},
      isAddWatermark: false,
      attachments: [] // 图片
    }
  },
  computed: {
    isShow: {
      get() {
        return this.visible
      },
      set(val) {
        this.$emit('update:visible', val)
      }
    }
  },
  created() {
    this.fetchFormData()
  },
  methods: {
    handleUploadImage(fileList) {
      this.attachments = fileList
    },

    // 检查照片
    checkAttachments(rule, value, callback) {
      for (const key in this.attachments) {
        if (this.attachments[key] && this.attachments[key].status === 'error') {
          // eslint-disable-next-line standard/no-callback-literal
          callback('照片上传错误')
          return
        }
      }

      callback()
    },

    fetchFormData() {
      if (this.orderType === 'subscribe') {
        findSubscribeOrderDelivered(this.serviceOrderId, {}).then((res) => {
          if (res.code === 0) {
            this.defaultFileList = []
            if (res.data.images != null && res.data.images.length > 0) {
              res.data.images.forEach((item, index) => {
                this.defaultFileList.push({
                  uid: index,
                  name: 'image.png',
                  status: 'done',
                  url: item.url,
                  response: item.response
                })
              })
            }
            this.$nextTick(() => {
              this.form.setFieldsValue(res.data)
              this.attachments = this.defaultFileList
            })
          }
        })
      } else {
        findAdditionalItemOrderDelivered(this.serviceOrderId, {}).then((res) => {
          if (res.code === 0) {
            this.defaultFileList = []
            if (res.data.images != null && res.data.images.length > 0) {
              res.data.images.forEach((item, index) => {
                this.defaultFileList.push({
                  uid: index,
                  name: 'image.png',
                  status: 'done',
                  url: item.url,
                  response: item.response
                })
              })
            }
            this.$nextTick(() => {
              this.form.setFieldsValue(res.data)
              this.attachments = this.defaultFileList
            })
          }
        })
      }
    },

    handleSubmit(e) {
      e.preventDefault()
      if (this.submitting) {
        this.$warning({
          title: '请勿重复提交',
          content: ''
        })
        return
      }
      this.form.validateFields((err, values) => {
        if (!err) {
          this.submitting = true
          if (this.orderType === 'subscribe') {
            const data = {
              ...values,
              attachments: this.$lodash.map(this.attachments, 'response')
            }

            if (this.isUpdate) {
              updateSubscribeOrderDelivered(this.serviceOrderId, data).then((res) => {
                if (res.code === 0) {
                  // 关闭模态框
                  this.isShow = false
                  // 告知父组件已完成
                  this.$emit('completed')
                }
                this.submitting = false
              })
            } else {
              subscribeOrderDelivered(this.serviceOrderId, data).then((res) => {
                if (res.code === 0) {
                  // 关闭模态框
                  this.isShow = false
                  // 告知父组件已完成
                  this.$emit('completed')
                }
                this.submitting = false
              })
            }
          } else {
            const data = {
              ...values,
              attachments: this.$lodash.map(this.attachments, 'response')
            }

            if (this.isUpdate) {
              updateAdditionalItemOrderDelivered(this.serviceOrderId, data).then((res) => {
                if (res.code === 0) {
                  // 关闭模态框
                  this.isShow = false
                  // 告知父组件已完成
                  this.$emit('completed')
                }
                this.submitting = false
              })
            } else {
              additionalItemOrderDelivered(this.serviceOrderId, data).then((res) => {
                if (res.code === 0) {
                  // 关闭模态框
                  this.isShow = false
                  // 告知父组件已完成
                  this.$emit('completed')
                }
                this.submitting = false
              })
            }
          }
        }
      })
    }
  }
}
</script>
